import React from 'react';

function GlassCard({ children, className = '', hover = true }) {
  return (
    <div className={`glass-card ${hover ? 'hover-lift' : ''} ${className}`.trim()}>
      {children}
    </div>
  );
}

export default GlassCard;
